import ChatMessage from "../model/ChatMessage";

export default class ChatPlayerMessageEvent {
    /**
     * @constructor
     * @param {string} type 
     * @param {ChatMessage} chatMessage 
     */
    constructor(type, chatMessage) {
        this.type = type;
        this.chatMessage = chatMessage;
    }
}

ChatPlayerMessageEvent.SENT = "ChatPlayerMessageEvent.SENT";